export const LANGUAGE_FR = 'fr';
export const LANGUAGE_EN = 'en';